module.exports = __webpack_public_path__ + "img/student_33.18d2e2e2.png";